export enum WindowOrientation {
  portrait,
  landscape,
}
